import { render, staticRenderFns } from "./LabelStatementsLicensorPaymentsDialog.vue?vue&type=template&id=54d3144e"
import script from "./LabelStatementsLicensorPaymentsDialog.vue?vue&type=script&lang=js"
export * from "./LabelStatementsLicensorPaymentsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports